import {
  Box,
  Typography,
  useMediaQuery
} from '@mui/material'
import { every, includes, isArray, isNil, map, replace, size, toString } from 'lodash/fp'
import {
  useTranslate
} from 'react-admin'
import { CheckInput, DateInput, ScheduleButton, TextInput, TextShow } from '../Util'
import { FieldValues, useFormContext } from 'react-hook-form'
import { Config } from '../../functions/types'

export const displayRule = (config: Config, data: FieldValues): boolean => {
  const {
    displayRules
  } = config
  if (isNil(displayRules)) {
    return true
  }
  const {
    sources
  } = displayRules
  const result = every((sourceItem: { source: string, values: string[] }) => {
    const { source, values } = sourceItem
    const dataValue = data[source]
    return isArray(dataValue) ? every((item: string) => includes(item)(dataValue))(values) : includes(dataValue)(values)
  })(sources)
  return result
}
const FormInput: React.FC<{
  configs?: Record<string, Config>
}> = ({ configs }): JSX.Element => {
  const translation = useTranslate()
  const { getValues } = useFormContext()
  const data = getValues()
  const isDesktop = useMediaQuery('(min-width: 900px)')
  if (isNil(configs)) return <></>
  return (
    <Box>
      <Box display="grid" justifyContent={"center"} marginY={5}>
        <Typography variant="h6" sx={{ borderBottom: 2, borderColor: 'GrayText', color: "gray", whiteSpace: 'pre-line' }}>{replace(' ', isDesktop ? ' ' : '\n')(translation('resources.requests.title'))}</Typography>
      </Box>
      {map(
        (index: number) => {
          const source = `No${toString(index)}`
          const config = configs[source as keyof typeof configs] as Config
          const {
            inputType,
            label,
            placeholder,
            required,
            values,
            labels1,
            labels2,
            descrioptions1,
            descrioptions2,
            inputMode,
            multiline,
            content
          } = config
          return displayRule(config, data) && (
            <Box display={"flex"} flexDirection={"column"} justifyContent={"center"} paddingBottom={'1em'} >
              {inputType === "text" && <TextInput fields='resources.requests' source={source} placeholder={placeholder} inputMode={inputMode} multiline={multiline} required={required} />}
              {inputType === "check" && <CheckInput fields='resources.requests' source={source} title={label} values={values} labels1={labels1} labels2={labels2} descriptions1={descrioptions1} descriptions2={descrioptions2} isRequired={required} />}
              {inputType === "date" && <DateInput fields='resources.requests' source={source} />}
              {inputType === "dates" && <ScheduleButton source={source} label={`resources.requests.${source}`} />}
              {inputType === "show" && <TextShow>{content}</TextShow>}
              {/* {inputType === "radio" && <DateInput fields='resources.requests' source={source} />}
              {inputType === "select" && <DateInput fields='resources.requests' source={source} />} */}
            </Box>)
        })(Array.from(new Array(size(configs)), (_, index) => index + 1))
      }
    </Box >
  )
}

export default FormInput